import { useCallback, useEffect, useRef } from 'react';

/** One owner for automatic loads and manual refreshes, including StrictMode replay. */
export default function useLatestRequest() {
  const active = useRef<AbortController | null>(null);
  const cancel = useCallback(() => {
    active.current?.abort();
    active.current = null;
  }, []);
  const begin = useCallback(() => {
    cancel();
    const controller = new AbortController();
    active.current = controller;
    return controller.signal;
  }, [cancel]);
  useEffect(() => cancel, [cancel]);
  return { begin, cancel };
}
